// extracted by mini-css-extract-plugin
export default {"header":"styles_header__ry3m+","logo":"styles_logo__KKJIk","main":"styles_main__JCGk0","right":"styles_right__ymHcp"};